import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { ClientAuthContext } from '../common/constants';

export default function ProtectedRoute({ children }) {
    const auth = useContext(ClientAuthContext);

    if (!auth.initialized) {
        return null;
    }

    if (!auth.isAuthenticated) {
        return <Navigate to="/connexion" replace />;
    }

    return children;
}
